"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompanySelector = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _CompanySelectorStyle = _interopRequireDefault(require("./CompanySelectorStyle"));

require("./CompanySelector.css");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CompanySelector =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CompanySelector, _React$Component);

  function CompanySelector(props) {
    var _this;

    _classCallCheck(this, CompanySelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompanySelector).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "container", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isDropdownExpanded: false,
      company: {
        name: null,
        id: null
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOutside", function (event) {
      if (_this.container.current && !_this.container.current.contains(event.target)) {
        _this.setState({
          isDropdownExpanded: false
        });
      }
    });

    if (_this.props.selectedCompany) _this.state.company = {
      name: _this.props.selectedCompany.name,
      id: _this.props.selectedCompany.id
    };
    _this.collapseDropdown = _this.collapseDropdown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.expandDropdown = _this.expandDropdown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(CompanySelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "collapseDropdown",
    value: function collapseDropdown(company) {
      if (company) {
        this.setState({
          company: company
        });
        if (this.props.updateCompanyCallback) this.props.updateCompanyCallback();
      }

      this.setState({
        isDropdownExpanded: false
      });
    }
  }, {
    key: "expandDropdown",
    value: function expandDropdown() {
      this.setState({
        isDropdownExpanded: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var hasMultipleCompanies = this.props.companies.length > 1;
      return _react.default.createElement("div", {
        className: "top-nav-dropdown-container",
        ref: this.container
      }, _react.default.createElement(MenuItem, {
        name: "AccountIndicator",
        title: this.state.company.name,
        text: "(".concat(this.state.company.id, ")"),
        dataId: 'topnav-accountswitcher',
        onClick: hasMultipleCompanies ? function () {
          return _this2.expandDropdown();
        } : function () {},
        showDownArrow: hasMultipleCompanies,
        additionalClasses: 'account-dropdown'
      }), hasMultipleCompanies ? _react.default.createElement(CompanySelectorDropdown, _extends({}, this.props, {
        companies: this.props.companies,
        selectedCompany: this.state.company.id,
        show: this.state.isDropdownExpanded,
        collapseDropdown: function collapseDropdown(x) {
          return _this2.collapseDropdown(x);
        }
      })) : _react.default.createElement("div", null));
    }
  }]);

  return CompanySelector;
}(_react.default.Component);

exports.CompanySelector = CompanySelector;

var CompanySelectorDropdown = function CompanySelectorDropdown(_ref) {
  var companies = _ref.companies,
      selectedCompany = _ref.selectedCompany,
      show = _ref.show,
      collapseDropdown = _ref.collapseDropdown,
      restProps = _objectWithoutProperties(_ref, ["companies", "selectedCompany", "show", "collapseDropdown"]);

  var changeCompany = function changeCompany(value, _ref2) {
    var action = _ref2.action;

    if (action === 'select-option') {
      var _selectedCompany = value ? value.value : null;

      if (_selectedCompany) {
        collapseDropdown(_selectedCompany);
      }
    }
  };

  var companyList = companies.map(function (c) {
    return {
      value: c,
      label: "".concat(c.name, " (").concat(c.id, ")")
    };
  }).sort(function (a, b) {
    return a.label.toUpperCase().localeCompare(b.label.toUpperCase());
  });

  var CustomMenu = function CustomMenu(props) {
    return _react.default.createElement(_reactSelect.components.Menu, props, props.children, _react.default.createElement("div", {
      style: {
        fontWeight: 'bold',
        textAlign: 'center',
        marginTop: '4px',
        marginBottom: '8px',
        display: 'none'
      }
    }, "ADD LINKED ACCOUNT"));
  };

  var CustomInput = function CustomInput(props) {
    return _react.default.createElement(_reactSelect.components.Input, _extends({}, props, {
      autoFocus: true
    }), props.children);
  };

  return show ? _react.default.createElement("div", {
    className: "top-nav-dropdown company-switcher-dropdown"
  }, _react.default.createElement(DropdownHeader, {
    label: restProps.selectText || 'Select Account',
    collapseDropdown: collapseDropdown
  }), _react.default.createElement(_reactSelect.default, {
    components: {
      Menu: CustomMenu,
      Input: CustomInput
    },
    styles: _CompanySelectorStyle.default,
    menuIsOpen: true,
    onChange: changeCompany,
    options: companyList,
    isOptionSelected: function isOptionSelected(option) {
      return option.value === selectedCompany;
    },
    placeholder: _react.default.createElement(CompanySelectorPlaceholder, restProps)
  })) : _react.default.createElement("div", null);
};

var MenuItem = function MenuItem(_ref3) {
  var title = _ref3.title,
      text = _ref3.text,
      icon = _ref3.icon,
      onClick = _ref3.onClick,
      additionalClasses = _ref3.additionalClasses,
      dataId = _ref3.dataId,
      _ref3$showDownArrow = _ref3.showDownArrow,
      showDownArrow = _ref3$showDownArrow === void 0 ? false : _ref3$showDownArrow;
  var textElement = text ? _react.default.createElement("span", {
    className: "top-nav-menu-item-text"
  }, text) : null;
  var maybeDownArrow = showDownArrow ? _react.default.createElement("span", {
    className: "material-icons icon-menu-item"
  }, "expand_more") : null;
  return _react.default.createElement("div", {
    className: "top-nav-menu-item ".concat(additionalClasses || ''),
    onClick: onClick,
    "data-id": dataId
  }, icon, title ? _react.default.createElement("span", {
    className: "top-nav-menu-item-title truncate"
  }, title, "\xA0") : null, textElement, maybeDownArrow);
};

var DropdownHeader = function DropdownHeader(_ref4) {
  var label = _ref4.label,
      collapseDropdown = _ref4.collapseDropdown;
  return _react.default.createElement("div", {
    className: "top-nav-dropdown-header"
  }, _react.default.createElement("div", null, label), _react.default.createElement("div", {
    className: "icon-dropdown",
    onClick: function onClick() {
      return collapseDropdown();
    }
  }, _react.default.createElement("i", {
    className: "material-icons",
    alt: "close"
  }, "close")));
};

var CompanySelectorPlaceholder = function CompanySelectorPlaceholder(_ref5) {
  var restProps = _extends({}, _ref5);

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    style: {
      width: '48px',
      height: '48px',
      display: 'inline-block',
      padding: '15px'
    }
  }, _react.default.createElement("i", {
    className: "material-icons icon-search",
    style: {
      fontSize: '18px'
    },
    alt: "search icon"
  }, "search"), ' '), _react.default.createElement("div", {
    style: {
      fontStyle: 'italic',
      lineHeight: '48px',
      display: 'inline-block',
      position: 'relative',
      top: '-2px'
    }
  }, restProps.searchAccountsText || 'Search for accounts...'));
};